<template>
  <div class="MeetingHome">
    <component
      :is="template"
      :show="show"
      :type="type"
      :hotelName="hotelName"
      :brandUrl="brandUrl"
      :h5HeaderBg="h5HeaderBg"
      :languageType="languageType"
      :language="language"
      :languageList="languageList"
      :stringList="stringList"
      :meetingMenuShow="meetingMenuShow"
      :address="address"
      :phone="phone"
      :showLanguageChoose="showLanguageChoose"
      @chooseLanguage="chooseLanguage"
      @gotoMeetingServices="(v, s) => gotoMeetingServices(v, s)"
      @pdfView="(inno, title) => pdfView(inno, title)"
      @changeLanguage="(val) => changeLanguage(val)"
    ></component>
  </div>
</template>

<script>
import TemplateA from "./MeetingHomeTemplate/templateA.vue";
import TemplateB from "./MeetingHomeTemplate/templateB.vue";

import { getAction, postAction } from "@/api/manage";
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import moment, { lang } from "moment-timezone";
import { encryptedDES } from "@/utils/DES.js";
import { Toast } from "vant";

export default {
  components: {
    TemplateA,
    TemplateB,
  },
  metaInfo: {
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no",
      },
    ],
  },
  name: "Home",
  data() {
    return {
      url: {
        login: "/api/common/user/hotel_dept_name/login",
        hotelQuery: "/api/sys_admin/hotel/query",
        hotelinfo: "/adminApi/hotelinfo/infobyhotel",
        getPageInfo: "/adminApi/file/page",
        queryRoomNum: "/api/sys_admin/hotel/room/query2/",
        getKeyWord: "/api/app/current_user/keywordsalldept/",
        getReplyList: "/adminApi/reply/listbyhotel",
        getIsInputPhone: "/adminApi/textconfig/list",
        createOrder: "/api/common/hotel/data/qrorder/create",
        getFileList: "/adminApi/file/filelist",
        getLanguageList: "/api/common/hotel/data/dict/by_key/languageQr",
        about: "/adminApi/test/qr/about1",
        meetingMenu: "/adminApi/file/meetingPage",
      },
      showLanguageChoose: false,
      brandUrl: "",
      hotelName: "",
      pageInfo: {},
      address: "",
      phone: "",
      rooms: [], //所有房间
      submiting: false,
      loading: null,
      show: false,
      languageList: Vue.ls.get("languageList"),
      language: Vue.ls.get("language"),
      languageType: Vue.ls.get("languageType"),
      stringList: {},
      hotelInno: "",
      type: "",
      tsp: 0,
      meetingMenu: [],
      meetingMenuShow: [], // 可展示的菜单按钮数组
      template: "",
      h5HeaderBg: "",
    };
  },
  computed: {
    ...mapGetters({
      amcniticsRequest: "amcniticsRequest", //Amcnitics的所有request
      informationRequest: "informationRequest",
    }),
  },
  async created() {
    this.type = this.$route.query.type;
    this.hotelInno = this.$route.query.inno;
    this.loading = Toast.loading({
      forbidClick: true,
      duration: 0,
    });
    this.show = false;
    console.log(this.$route);
    this.tsp = this.$route.query.tsp;
    let now = new Date().getTime();
    console.log(now - this.tsp * 1000);
    if (this.$route.query.room) {
      Vue.ls.set("room", this.$route.query.room, 1000 * 60 * 60 * 24);
    } else {
      Vue.ls.set("room", "");
    }
    if (now - this.tsp * 1000 > 1000 * 60 * 60 * 24) {
      this.loading.clear();
      //如果是走了这个about 后台调用一下接口 打log
      getAction(this.url.about).then((res) => {});
      this.$router.push({ name: "About" });
    } else {
      if (Vue.ls.get("HTTOKEN")) {
        if (this.$route.query.inno != Vue.ls.get("inno")) {
          this.getToken();
        } else {
          this.getLanguageList();
          this.getHotelInfo();
          this.getAllRequest();
          this.getRoomNum();
          if (this.$route.query.type == "nonguest") {
            Vue.ls.set("type", this.$route.query.type, 1000 * 60 * 60 * 24);
            this.getMeetingMenu();
          }
        }
      } else {
        this.getToken();
      }
    }
    if (!Vue.ls.get("language") || !Vue.ls.get("languageType")) {
      Vue.ls.set("language", "en");
      Vue.ls.set("languageType", "English");
      this.language = "en";
      this.languageType = "English";
    }
    let languageJsonName = "String_" + Vue.ls.get("language") + ".json";
    this.stringList = await import("@/data/" + languageJsonName);
  },
  methods: {
    moment,
    ...mapActions([
      "editColor",
      "editAmcniticsRequest",
      "editInformationRequest",
      "editShowPhone",
      "editRoomList",
    ]),
    moveToRight(ref) {
      let scrollDiv = this.$refs[ref];
      this.$nextTick(() => {
        scrollDiv.scrollTo({
          left: 360,
          behavior: "smooth",
        });
      });
    },
    chooseLanguage() {
      this.showLanguageChoose = true;
    },
    async changeLanguage(val) {
      let languageJsonName = "String_" + val + ".json";
      this.stringList = await import("@/data/" + languageJsonName);
      this.language = val;
      Vue.ls.set("language", val);
      this.showLanguageChoose = false;

      let langeuage = Vue.ls.get("language");
      this.languageType = this.languageList.filter((i) => {
        return i.value == val;
      })[0].type;
      Vue.ls.set("languageType", this.languageType);
      this.meetingMenu.map((item, index) => {
        let meetingMenuTitle = JSON.parse(item.title2);
        item.handleTitle = meetingMenuTitle[langeuage];
      });
    },
    pdfView(inno, title) {
      let urlType = inno.split(".")[inno.split(".").length - 1];

      //创建订单
      let now = new Date();
      let createTime = moment(now).tz(Vue.ls.get("timeZone"));
      let time = new Date().valueOf().toString();
      let params = {
        createTime: createTime.utc().format(),
        fdaction: "",
        fdhour: Vue.ls.get("overNightHoursInfo"),
        hotelId: Vue.ls.get("hotelId"),
        hotelDeptId: "",
        inquiryNum: "",
        notes: "",
        requestType: "guest",
        roomNumber: Vue.ls.get("room") ? Vue.ls.get("room") : "GSD",
        requestTime: createTime.utc().format(),
        serviceKey: title ? title : "Guest Service Directory",
        serviceType: "gsd",
        createTimeValue: time,
        tid: encryptedDES(time.substring(time.length - 8)),
      };

      if (!this.submiting) {
        this.submiting = true;
        postAction(this.url.createOrder, params)
          .then((res) => {
            if (res.success) {
              this.submiting = false;
              if (
                urlType == "xlsx" ||
                urlType == "docx" ||
                urlType == "pptx" ||
                urlType == "xls" ||
                urlType == "doc" ||
                urlType == "ppt"
              ) {
                window.location.href =
                  "https://view.officeapps.live.com/op/view.aspx?src=" + inno;
              } else if (
                urlType == "jpg" ||
                urlType == "png" ||
                urlType == "jpeg" ||
                urlType == "gif"
              ) {
                window.location.href = inno;
              } else if (urlType == "pdf") {
                this.$router.push({
                  name: "PdfView",
                  query: { inno: inno },
                });
              } else {
                if (inno.indexOf("home?hotelname") != -1) {
                  window.location.href =
                    inno + "&room=" + this.$route.query.room;
                } else {
                  window.location.href = inno;
                }
              }
            } else {
              this.submiting = false;
            }
          })
          .catch((e) => {
            this.submiting = false;
          });
      }
    },
    getIsInputPhone() {
      let form = {
        hotelId: Vue.ls.get("hotelId"),
        size: 10,
        current: 1,
      };
      postAction(this.url.getIsInputPhone, form).then((res) => {
        if (res.status == 0) {
          res.data.records.forEach((item) => {
            if (Vue.ls.get("type") == "guest") {
              if (item.requestType == "Guest Room Request") {
                if (item.textResponse == "Disable") {
                  this.editShowPhone(0);
                  return;
                }
                if (item.textResponse == "Enable(Optional)") {
                  this.editShowPhone(1);
                  return;
                }
                if (item.textResponse == "Enable(Required)") {
                  this.editShowPhone(2);
                  return;
                }
              }
            } else if (Vue.ls.get("type") == "nonguest") {
              if (item.requestType == "Meeting Room Request") {
                if (item.textResponse == "Disable") {
                  this.editShowPhone(0);
                  return;
                }
                if (item.textResponse == "Enable(Optional)") {
                  this.editShowPhone(1);
                  return;
                }
                if (item.textResponse == "Enable(Required)") {
                  this.editShowPhone(2);
                  return;
                }
              }
            }
          });
        }
      });
    },
    getReplyList() {
      let params = {
        hotelId: Vue.ls.get("hotelId"),
        type: "internal",
      };
      getAction(this.url.getReplyList, params).then((res) => {
        if (res.status == 0) {
          for (let element of res.data) {
            if (element.botTrigger == "556" || element.botTrigger == "557") {
              Vue.ls.set(
                "fdOption",
                element.botTriggerValue,
                1000 * 60 * 60 * 24
              );
              Vue.ls.set(
                "fdOptionReponse",
                element.botResponse2,
                1000 * 60 * 60 * 24
              );
              break;
            }
          }
          for (let element of res.data) {
            if (element.botTrigger == "677") {
              Vue.ls.set(
                "engHourReponse",
                element.botResponse2,
                1000 * 60 * 60 * 24
              );
              break;
            }
          }
        }
      });
    },
    getAllRequest() {
      if (this.amcniticsRequest.length == 0) {
        getAction(`${this.url.getKeyWord}${"fdkey"}`).then((res) => {
          if (res.status == 0) {
            this.editAmcniticsRequest(res.data);
          }
        });
      }
      if (this.informationRequest.length == 0) {
        getAction(`${this.url.getKeyWord}${"nonfdkey"}`).then((res) => {
          if (res.status == 0) {
            this.editInformationRequest(res.data);
          }
        });
      }
    },
    getRoomNum() {
      if (Vue.ls.get("type") == "guest") {
        getAction(`${this.url.queryRoomNum}${"guest"}/${"allmeeting"}`).then(
          (res) => {
            if (res.status == 0) {
              this.editRoomList(res.data);
            }
          }
        );
      } else if (Vue.ls.get("type") == "nonguest") {
        getAction(
          `${this.url.queryRoomNum}${"Meeting Room"}/${"allmeeting"}`
        ).then((res) => {
          if (res.status == 0) {
            this.editRoomList(res.data);
          }
        });
      }
    },
    getLanguageList() {
      getAction(this.url.getLanguageList).then((res) => {
        this.languageList = res.data;
        Vue.ls.set("languageList", res.data);
      });
    },
    getToken() {
      let params = {
        hotelDeptName: "qrbot",
        hotelName: this.$route.query.inno,
        password: "123456",
      };
      postAction(this.url.login, params).then((res) => {
        if (res.status == 0) {
          this.token = res.data.token;
          // Vue.ls.set("HTTOKEN", res.data.token, 1000 * 60 * 60 * 24);
          Vue.ls.set("HTTOKEN", res.data.token);
          // this.$router.push({
          //   query: merge(this.$route.query, { code: "" }),
          // });
          // let query = {};
          // if (this.$route.query.type) {
          //   query.type = this.$route.query.type;
          // }
          // query.inno = this.$route.query.inno;
          // if (this.$route.query.room) {
          //   query.room = this.$route.query.room;
          // }
          // query.noCode = "";
          // setTimeout(() => {
          //   this.$router.replace({ name: "Home", query: query });
          // }, 1000 * 60 * 5);
          this.getLanguageList();
          this.getHotelInfo();
          this.getAllRequest();

          if (this.$route.query.type) {
            Vue.ls.set("type", this.$route.query.type, 1000 * 60 * 60 * 24);
            this.getRoomNum();
          }
          if (this.$route.query.inno) {
            Vue.ls.set("inno", this.$route.query.inno, 1000 * 60 * 60 * 24);
          }
        }
      });
    },
    // 获取meeting 菜单
    getMeetingMenu() {
      getAction(this.url.meetingMenu, { hotelId: Vue.ls.get("hotelId") }).then(
        (res) => {
          this.meetingMenuShow = []; //初始化数组
          if (res.status == 0) {
            console.log(res);
            this.meetingMenu = res.data;
            let langeuage = Vue.ls.get("language");
            this.meetingMenu.map((item, index) => {
              let meetingMenuTitle = JSON.parse(item.title2);
              item.handleTitle = meetingMenuTitle[langeuage];
            });
            // 获取可以展示的菜单按钮列表（enable==true）
            for (let i = 0; i < this.meetingMenu.length; i++) {
              const item = this.meetingMenu[i];
              if (item.enable == true) {
                this.meetingMenuShow.push(item);
              }
            }
          }
        }
      );
    },

    getHotelInfo() {
      postAction(this.url.hotelQuery, { hotelNo: this.$route.query.inno }).then(
        (res) => {
          if (res.status == 0) {
            this.hotelName = res.data.name;
            Vue.ls.set("hotelName", res.data.name, 1000 * 60 * 60 * 24);
            Vue.ls.set("timeZone", res.data.timeZone, 1000 * 60 * 60 * 24);
            Vue.ls.set("hotelId", res.data.id, 1000 * 60 * 60 * 24);
            //判断是否启动夜间模式
            Vue.ls.set(
              "overNightHoursInfo",
              res.data.overNightHours,
              1000 * 60 * 60 * 24
            );
            // if (
            //   res.data.overNightHours != "disable" &&
            //   res.data.overNightHours != "Regular Operating Hour"
            // ) {
            //   Vue.ls.set("overNightHours", true, 1000 * 60 * 60 * 24);
            // } else {
            //   Vue.ls.set("overNightHours", false, 1000 * 60 * 60 * 24);
            // }
            if (
              res.data.overNightHours == "disable" ||
              res.data.overNightHours == "Regular Operating Hour"
            ) {
              Vue.ls.set("overNightHours", false, 1000 * 60 * 60 * 24);
            } else if (
              res.data.overNightHours == "Cycle Regular Operating Hour"
            ) {
              // Vue.ls.set("overNightHours", false, 1000 * 60 * 60 * 24);
              let now = new Date();
              let taody = moment(now)
                .tz(res.data.timeZone)
                .format("YYYY/MM/DD");
              let startTime = moment.tz(
                moment(taody + " " + res.data.fdStartTime).format(
                  "YYYY-MM-DD HH:mm"
                ),
                res.data.timeZone
              );
              let endTime = moment.tz(
                moment(
                  res.data.fdEndTime.replace("tomorrow_", taody + " ")
                ).format("YYYY-MM-DD HH:mm"),
                res.data.timeZone
              );
              if (this.getIsInTimeRange(startTime, endTime)) {
                Vue.ls.set("overNightHours", true, 1000 * 60 * 60 * 24);
              } else {
                Vue.ls.set("overNightHours", false, 1000 * 60 * 60 * 24);
              }
            } else {
              Vue.ls.set("overNightHours", true, 1000 * 60 * 60 * 24);
            }
            Vue.ls.set(
              "fdStartTime",
              res.data.fdStartTime,
              1000 * 60 * 60 * 24
            );
            Vue.ls.set("fdEndTime", res.data.fdEndTime, 1000 * 60 * 60 * 24);

            Vue.ls.set("engHour", res.data.engHour, 1000 * 60 * 60 * 24);
            Vue.ls.set("engEndTime", res.data.engEndTime, 1000 * 60 * 60 * 24);
            Vue.ls.set(
              "engStartTime",
              res.data.engStartTime,
              1000 * 60 * 60 * 24
            );
            Vue.ls.set(
              "engRequestTime",
              res.data.engRequestTime,
              1000 * 60 * 60 * 24
            );

            getAction(this.url.hotelinfo, { hotelId: res.data.id }).then(
              (r) => {
                if (r.status == 0) {
                  this.editColor("#" + r.data.color);
                  const customStyle = JSON.parse(r.data.customStyle);
                  if (customStyle && customStyle.template) {
                    this.template = customStyle.template || "TemplateA";
                    if (customStyle.template == "TemplateB") {
                      this.h5HeaderBg = customStyle.h5HeaderBg;
                    }
                  } else {
                    this.template = "TemplateA";
                  }

                  this.$store.commit("setTemplate", this.template);
                  this.$store.commit("setH5HeaderBg", this.h5HeaderBg);

                  this.show = true;
                  this.brandUrl =
                    "https://hotelfile353485474178.s3-accelerate.amazonaws.com/logo/" +
                    r.data.brand.toLowerCase().replaceAll(" ", "_") +
                    ".png";
                  this.phone = r.data.phone;
                  this.address =
                    r.data.address +
                    ", " +
                    r.data.city +
                    ", " +
                    r.data.state +
                    " " +
                    r.data.zipcode +
                    ", USA";
                  Vue.ls.set("hotelBrand", r.data.brand, 1000 * 60 * 60 * 24);
                }
              }
            );
            getAction(this.url.getPageInfo, { hotelId: res.data.id }).then(
              (r) => {
                if (r.status == 0) {
                  this.pageInfo = r.data;
                  if (this.pageInfo["Other"]) {
                    for (let element of this.pageInfo["Other"]) {
                      element.title2 = JSON.parse(element.title2);
                    }
                  }
                  if (this.pageInfo["Things To Do"]) {
                    for (let element of this.pageInfo["Things To Do"]) {
                      element.title2 = JSON.parse(element.title2);
                    }
                  }
                  if (this.pageInfo["Hotel Information"]) {
                    for (let element of this.pageInfo["Hotel Information"]) {
                      element.title2 = JSON.parse(element.title2);
                    }
                  }
                  if (this.pageInfo["Hotel Highlight(s)"]) {
                    for (let element of this.pageInfo["Hotel Highlight(s)"]) {
                      element.title2 = JSON.parse(element.title2);
                    }
                  }
                  if (this.pageInfo["Dine & Drink"]) {
                    for (let element of this.pageInfo["Dine & Drink"]) {
                      element.title2 = JSON.parse(element.title2);
                    }
                  }
                  this.loading.clear();
                  console.log(this.pageInfo);
                }
              }
            );
            postAction(this.url.getFileList, { hotelId: res.data.id }).then(
              (r) => {
                if (r.status == 0) {
                  Vue.ls.set(
                    "fileList",
                    r.data.htFileList,
                    1000 * 60 * 60 * 24
                  );
                }
              }
            );

            this.getReplyList();
            this.getIsInputPhone();
            if (this.$route.query.type == "nonguest") {
              this.getMeetingMenu();
            }
          }
        }
      );
    },
    goToAmenities() {
      let query = {};
      query.type = this.$route.query.type;
      query.inno = this.$route.query.inno;
      if (this.$route.query.room) {
        query.room = this.$route.query.room;
      }
      query.tsp = this.$route.query.tsp;
      this.$router.push({ name: "Amenity", query: query });
    },
    getIsInTimeRange(startTime, endTime) {
      let now = new Date();
      if (startTime.valueOf() < endTime.valueOf()) {
        return (
          startTime.valueOf() <= now.getTime() &&
          now.getTime() <= endTime.valueOf()
        );
      } else {
        return (
          startTime.valueOf() <= now.getTime() ||
          now.getTime() <= endTime.valueOf()
        );
      }
    },
    goToServices() {
      let query = {};
      query.type = this.$route.query.type;
      query.inno = this.$route.query.inno;
      if (this.$route.query.room) {
        query.room = this.$route.query.room;
      }
      query.tsp = this.$route.query.tsp;
      this.$router.push({ name: "Service", query: query });
    },
    // meeting 服务
    gotoMeetingServices(v, s) {
      let query = {};
      query.type = this.$route.query.type;
      query.inno = this.$route.query.inno;
      if (this.$route.query.room) {
        query.room = this.$route.query.room;
      }
      query.tsp = this.$route.query.tsp;
      // query.service = v;
      // query.serviceType = s;
      Vue.ls.set("meeting_service", s);

      this.$router.push({ name: "MeetingService", query: query });
    },
    goToMaintenance() {
      let query = {};
      query.type = this.$route.query.type;
      query.inno = this.$route.query.inno;
      if (this.$route.query.room) {
        query.room = this.$route.query.room;
      }
      query.tsp = this.$route.query.tsp;
      this.$router.push({ name: "Maintenance", query: query });
    },
    goToInformation() {
      let query = {};
      query.type = this.$route.query.type;
      query.inno = this.$route.query.inno;
      if (this.$route.query.room) {
        query.room = this.$route.query.room;
      }
      query.tsp = this.$route.query.tsp;
      this.$router.push({ name: "Information", query: query });
    },
  },
};
</script>

<style lang="scss" scoped>
.MeetingHome {
  height: 100%;
}
</style>
